module.exports = __webpack_public_path__ + "static/media/morrowind_logo.581236e5.png";